export default __webpack_public_path__ + "static/media/spain.60cf1705.svg";